import TopNav from "../components/Navbars/TopNav";
import RefereeInformationCard from "../components/information_cards/RefereeInformationCard";
import PersonalDetailsCard from "../components/information_cards/PersonalDetailsCard";
import AcademicDetailsSiwes from "../components/information_cards/AcademicDetailsSiwes";
import AcademicDetailsIT from "../components/information_cards/AcademicDetailsIT";
import AcademicDetailsNDE from "../components/information_cards/AcademicDetailsNDE";
import DocumentUpload from "../components/information_cards/DocumentUpload";
import ViewCandidate from "../components/information_cards/viewCandidate";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { ChevronRight, Home, ArrowLeft } from "lucide-react";
import { useViewAllinformationByid } from "../adapters/Requests";
import Footer from "../components/Navbars/footer";
import CommentsCard from "../components/information_cards/CommentsCard";
import { PageLoader } from "../components/ui/InlineLoader";

function ViewDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;
  const [, , type] = pathname.split("/");
  const { application_id } = useParams();
  let componentToRender;

  const allApplicationInformation = useViewAllinformationByid({
    application_id,
  });
  const { data, error, isLoading } = allApplicationInformation;
  const vacancy = data?.vacancy?.id;

  if (isLoading) return <PageLoader text="Loading application details..." />;
  if (error) return <div>Error: {error.message}</div>;

  switch (type) {
    case "it":
      componentToRender = (
        <AcademicDetailsIT details={data?.ApplicationsAcademicQualification} />
      );
      break;
    case "siwes":
      componentToRender = (
        <AcademicDetailsSiwes
          details={data?.ApplicationsAcademicQualification}
        />
      );
      break;
    case "gap":
      componentToRender = (
        <AcademicDetailsNDE details={data?.ApplicationNYSCDetails} />
      );
      break;
    default:
      componentToRender = <></>;
  }

  const getPageTitle = (t) => {
    const map = {
      it: "IT Application",
      siwes: "SIWES Application",
      gap: "NDE Application",
    };
    return map[t] || "Application Details";
  };

  return (
    <div className="flex flex-col w-full flex-1">
      <TopNav />
      <div className="container max-w-[1200px] mt-0">
        <div className="main gap-4">
          <div className="flex items-center justify-between w-full mb-2">
            <div className="flex items-center gap-2 text-sm text-gray-500">
              <Link
                to="/dashboard"
                className="flex items-center hover:text-green-600 transition-colors"
              >
                <Home size={16} />
              </Link>
              <ChevronRight size={16} className="text-gray-300" />
              <span className="font-semibold text-gray-900">
                {getPageTitle(type)}
              </span>
            </div>

            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-1 text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors"
            >
              <ArrowLeft size={16} /> Back
            </button>
          </div>

          <div className="space-y-5">
            <ViewCandidate />
            {data?.Comments?.length > 0 && (
              <CommentsCard comments={data?.Comments} />
            )}
            <div className="flex flex-col lg:flex-row lg:space-x-5">
              <div className="lg:w-[calc(60%)]">
                <div className="mb-5">
                  <PersonalDetailsCard
                    applicant={data.Applicant}
                    nextOfKins={data.ApplicationNextOfKins}
                  />
                  <DocumentUpload
                    documents={data?.ApplicationDocuments}
                    vacancy={vacancy}
                  />
                </div>
              </div>
              <div className="space-y-5 lg:w-[calc(60%)]">
                {componentToRender}
                {!(type === "siwes") ? (
                  <RefereeInformationCard referees={data.ApplicationReferees} />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ViewDetails;
